<template>
  <div>
    <b-overlay opacity="0.47" :show="showForm" rounded="sm">
      <template #overlay> &nbsp;<br /> </template>
      <b-row>
        <b-col cols="12" md="4">
          <b-form-group
            :label="$lang.subject"
            label-for="subject"
            :label-cols="$config.form.labelCol"
          >
            <b-form-input
              id="subject"
              type="text"
              autocomplete="off"
              v-model="$v.subject.$model"
              :state="$v.subject.$dirty ? !$v.subject.$error : null"
            ></b-form-input>

            <b-form-invalid-feedback id="subject-feedback"
              >{{ $lang.error_required | replace($lang.subject) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-group
            :label="$lang.name"
            label-for="name"
            :label-cols="$config.form.labelCol"
          >
            <b-form-input
              id="name"
              type="text"
              :autocomplete="$lang.name"
              v-model="$v.name.$model"
              :state="$v.name.$dirty ? !$v.name.$error : null"
            >
            </b-form-input>
            <b-form-invalid-feedback
              v-if="!$v.name.required"
              id="name-feedback"
            >
              {{ $lang.error_required | replace($lang.name) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-group
            :label="$lang.family"
            label-for="family"
            :label-cols="$config.form.labelCol"
          >
            <b-form-input
              id="family"
              v-model="$v.family.$model"
              type="text"
              :autocomplete="$lang.family"
              :state="$v.family.$dirty ? !$v.family.$error : null"
            >
            </b-form-input>
            <b-form-invalid-feedback
              v-if="!$v.family.required"
              id="family-feedback"
            >
              {{
                $lang.error_required | replace($lang.family)
              }}</b-form-invalid-feedback
            >
            <b-form-invalid-feedback
              v-if="$v.family.required && !$v.family.maxLengh"
              id="family-feedback"
            >
              {{
                $lang.error_max | replace($lang.family, "بین 3 تا 35")
              }}</b-form-invalid-feedback
            >
          </b-form-group>
        </b-col>

        <b-col cols="12" md="4">
          <b-form-group
            :label="$lang.mobile"
            label-for="mobile"
            :label-cols="$config.form.labelCol"
          >
            <b-form-input
              type="text"
              :autocomplete="$lang.mobile"
              v-model="$v.mobile.$model"
              :state="$v.mobile.$dirty ? !$v.mobile.$error : null"
            >
            </b-form-input>
            <b-form-invalid-feedback id="father_name-feedback">
              {{ $lang.error_required | replace($lang.mobile) }}
            </b-form-invalid-feedback>
            <div class="invalid-feedback" v-if="!$v.mobile.numeric">
              {{ $lang.error_numeric | replace($lang.mobile) }}
            </div>
            <div
              class="invalid-feedback"
              v-if="
                $v.mobile.numeric && !$v.mobile.minLength | !$v.mobile.maxLength
              "
            >
              {{ $lang.error_max | replace($lang.mobile, 11) }}
            </div>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-group
            :label="$lang.email"
            label-for="email"
            :label-cols="$config.form.labelCol"
          >
            <b-form-input
              id="email"
              type="text"
              autocomplete="off"
              v-model="$v.email.$model"
              :state="$v.email.$dirty ? !$v.email.$error : null"
            ></b-form-input>
            <b-form-invalid-feedback id="email-feedback"
              >{{ $lang.error_required | replace($lang.email) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-group
            :label="$lang.phone"
            label-for="phone"
            :label-cols="$config.form.labelCol"
          >
            <b-form-input
              type="text"
              :autocomplete="$lang.phone"
              v-model="$v.phone.$model"
              :state="$v.phone.$dirty ? !$v.phone.$error : null"
            >
            </b-form-input>
            <b-form-invalid-feedback id="father_name-feedback">
              {{ $lang.error_required | replace($lang.phone) }}
            </b-form-invalid-feedback>
            <div class="invalid-feedback" v-if="!$v.phone.numeric">
              {{ $lang.error_numeric | replace($lang.phone) }}
            </div>
            <div
              class="invalid-feedback"
              v-if="
                $v.phone.numeric && !$v.phone.minLength | !$v.phone.maxLength
              "
            >
              {{ $lang.error_max | replace($lang.phone, 11) }}
            </div>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group :label="$lang.description" :label-cols="12">
            <b-form-textarea
              id="description"
              v-model="$v.description.$model"
              type="text"
              :autocomplete="$lang.description"
              :rows="4"
              :state="$v.description.$dirty ? !$v.description.$error : null"
            >
            </b-form-textarea>
            <b-form-invalid-feedback id="description-feedback"
              >{{ $lang.error_required | replace($lang.description) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
    </b-overlay>
  </div>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  numeric,
} from "vuelidate/lib/validators";
export default {
  name: "contact-form",
  validations: {
    name: {
      required,
    },
    family: {
      required,
    },
    email: {},
    phone: {
      minLength: minLength(11),
      maxLength: maxLength(11),
      numeric,
    },
    mobile: {
      required,
      numeric,
      minLength: minLength(11),
      maxLength: maxLength(11),
    },
    description: {
      required,
    },
    subject: {
      required,
    },
    acting_description: {},
  },
  inject: ["contactUsWtRepository"],
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      name: null,
      family: null,
      email: null,
      phone: null,
      mobile: null,
      description: null,
      subject: null,
      loading: false,
      trackingData: null,
      showForm: true,
      acting_description: null,
    };
  },
  methods: {
    handleBack() {
      if (this.isModal) {
        this.$emit("modal-end-up");
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    async postContactUs() {
      this.$v.$touch();

      if (this.$v.$anyError) {
        return;
      }
      let payload = {
        description: this.description,
        subject: this.subject,
        name: this.name,
        family: this.family,
        email: this.email,
        tel: this.phone,
        mobile: this.mobile,
        acting_description: this.acting_description,
      };
      this.$emit("submit");
    },
    fetchData() {
      if (this.item) this.description = this.item.description;
      this.subject = this.item.subject;
      this.name = this.item.name;
      this.family = this.item.family;
      this.email = this.item.email;
      this.tel = this.item.phone;
      this.mobile = this.item.mobile;
      this.description = this.item.description;
    },
  },
  created() {
    this.fetchData();
  },
};
</script>
